import { Container, Flex, IconButton } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'

import * as React from 'react'

import { RouteComponentProps, withRouter } from 'react-router'

import { color, ColorProps, space, SpaceProps } from 'styled-system'

import { useAppContext } from '../../../context/AppProvider'
import { useHistory } from 'react-router-dom'
import { VscClose, VscArrowLeft } from 'react-icons/vsc'

type HeaderProps = RouteComponentProps &
  ColorProps & {
    color?: string
    size?: number
    id?: string
    open?: boolean
    getLoggedInUser?: () => { name?: string; id: string }
    leftElement?: React.ReactNode
    rightElement?: React.ReactNode
    canGoBack?: boolean
  }

type HeaderContProps = SpaceProps &
  ColorProps & {
    color?: string
    open?: boolean
  }

const HeaderCont = styled(motion.div as any)<HeaderContProps>`
  ${space};
  ${color};
  top: 0;
  right: 0;
  z-index: 1290;
  display: flex;
  position: fixed;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  height: 60px;
  left: ${(props) => (props.open ? '230px' : '64px')};
  @media screen and (max-width: 48em) {
    left: 0;
    height: 56px;
  }
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
`

const Header: React.FC<HeaderProps> = ({ leftElement, rightElement, canGoBack, ...rest }) => {
  const { drawerOpen, drawerOpen2, rightSidebarWidth } = useAppContext()
  const history = useHistory()
  return (
    <HeaderCont
      pl={drawerOpen ? '136px' : 0}
      pr={drawerOpen2 ? `${rightSidebarWidth + 6}px` : { base: 4, md: 32 }}
      {...rest}
    >
      <Container maxW="8xl" px={{ base: 3, md: 6, lg: 8 }}>
        <Flex align="center">
          {canGoBack ? (
            <IconButton
              as={drawerOpen2 ? VscClose : VscArrowLeft}
              onClick={() => history.goBack()}
              cursor="pointer"
              color="gray.600"
              size="sm"
              p={2}
              rounded="0"
              _hover={{ bg: 'gray.100', color: 'gray.900' }}
              aria-label={drawerOpen2 ? 'Close Menu' : 'Open Menu'}
            />
          ) : (
            leftElement
          )}
          <Flex flex={1} justify="flex-end" direction="row" height="100%">
            <Flex flexDirection="row" justifyContent="center" alignItems="center" height="100%">
              {rightElement}
            </Flex>
          </Flex>
        </Flex>
      </Container>
    </HeaderCont>
  )
}

export default withRouter(Header)

Header.defaultProps = {
  bg: 'white'
}
